module.exports = __webpack_public_path__ + "static/media/gb6.b6b96c17.png";